// extracted by mini-css-extract-plugin
export var actionButton = "_ol-0";
export var actionMenuContainer = "_ol-i";
export var bubble = "_ol-2";
export var bubbleActionMenu = "_ol-j";
export var bubbleContext = "_ol-6";
export var bubbleItems = "_ol-7";
export var customer = "_ol-3";
export var divider = "_ol-8";
export var fileList = "_ol-9";
export var hiddenComment = "_ol-o";
export var infoAbove = "_ol-a";
export var internal = "_ol-4";
export var lightActionButton = "_ol-1";
export var link = "_ol-b";
export var merchant = "_ol-5";
export var message = "_ol-c";
export var profilePicture = "_ol-e";
export var quillToolbarContainer = "_ol-f";
export var senderDate = "_ol-g";
export var senderDateCustomer = "_ol-h";
export var senderName = "_ol-d";
export var time = "_ol-k";
export var uploadedImage = "_ol-l";
export var username = "_ol-m";
export var xsmall = "_ol-n";